export const CHANNELS = {
    APP: 'APP',
    CHAT: 'CHAT',
    CHATBOT: 'CHATBOT',
    TELEFONIA: 'TELEFONÍA',
} as const;

export type Channel = (typeof CHANNELS)[keyof typeof CHANNELS] | string;

export const SOURCES = {
    SWITCH: 'SWITCH',
    CASES_GENERAL_INFO: 'CASES_GENERAL_INFO',
    QUOTATION: 'QUOTATION',
    SARLAFT: 'SARLAFT',
    CASES_GENERAL: 'CASES_GENERAL',
    PQR: 'PQR',
} as const;

export type Source = (typeof SOURCES)[keyof typeof SOURCES];

export type InteractionRow = {
    source: Source;
    caseId?: string | null;
    sarlaftId?: string | null;
    createdAt?: string;
    typification?: string | null;
    observation?: string | null;
    caseStatus?: string | null;
    plate?: string | null;
    policy?: string | null;
    callId?: string | null;
    userName?: string | null;
};
